import createTranslator, { ITranslator } from 'lib/translatorHelper'

const Translator = createTranslator()

const useTranslator: () => ITranslator = () => {
  return Translator
}

export { useTranslator }
